import enMessages from '../locales/fa_IR.json';

const FaLang = {
  messages: {
    ...enMessages
  },
  locale: 'fa-IR',
};
export default FaLang;
